var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9286 0.881348C21.6214 0.881348 27.8571 7.11706 27.8571 14.8099C27.8571 20.6956 23.7214 27.1099 15.5571 34.1213C15.1032 34.5113 14.5244 34.7255 13.9259 34.725C13.3274 34.7245 12.749 34.5093 12.2957 34.1185L11.7557 33.6499C3.95286 26.8213 0 20.5642 0 14.8099C0 7.11706 6.23571 0.881348 13.9286 0.881348ZM13.9286 9.45278C12.5078 9.45278 11.1452 10.0172 10.1405 11.0218C9.13584 12.0265 8.57143 13.3891 8.57143 14.8099C8.57143 16.2307 9.13584 17.5933 10.1405 18.598C11.1452 19.6027 12.5078 20.1671 13.9286 20.1671C15.3494 20.1671 16.712 19.6027 17.7166 18.598C18.7213 17.5933 19.2857 16.2307 19.2857 14.8099C19.2857 13.3891 18.7213 12.0265 17.7166 11.0218C16.712 10.0172 15.3494 9.45278 13.9286 9.45278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/UBICACION.0857a35d3ea1da7e76447e65ba56b38c.svg";
export { ForwardRef as ReactComponent };